<template>
  <div class="foot-container">
    <div class="foot-box">
      <div class="logo">
        <img src="../../assets/newImg/logo1.png" alt="" />
      </div>
      <div class="text">
        版权所有@2020 石家庄市国经人力资源管理有限公司<br />
        {{ footerInfo.address }}<br />
        国经人力<br />
        电话: {{ footerInfo.telephone }} 邮编:{{ footerInfo.email }}<br />
        <a href="http://beian.miit.gov.cn/" target="_blank" class="recordNo">{{
          footerInfo.recordNo
        }}</a>
        <br />冀公网安备 13012302000387号
      </div>
      <div class="code">
        <img src="../../assets/newImg/code.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footerInfo: {},
    };
  },
  mounted() {
    this.footerInfo = window.indexBottom;
    // console.log(this.footerInfo, 22222);
  },
};
</script>

<style scoped>
.foot-container {
  background-color: rgb(64, 71, 86);
  width: 100%;
}
.foot-container .foot-box {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.foot-container .foot-box .logo {
  width: 144px;
  height: 140.51px;
}
.foot-container .foot-box .logo img {
  width: 100%;
  height: 100%;
}
.foot-container .foot-box .code {
  width: 144px;
  height: 144px;
}
.foot-container .foot-box .code img {
  width: 100%;
  height: 100%;
}
.foot-container .foot-box .text {
  color: rgb(255, 255, 255);
  font-family: PingFang SC;
  font-size: 18px;
  margin: 28px 0px;
}
.foot-container .foot-box .text .recordNo {
  color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/view/base/footer.vue